import * as apiUtils from '.'

export const acceptTos = (newsletterOptedIn: boolean) =>
  apiUtils.POST('/user/tos-acceptance', { newsletterOptedIn })

interface TosAcceptanceReportUser {
  id: string
  nameFirst: string | null
  nameLast: string | null
  email: string
}

// Hand-written mirror of the Zod output schema of
// GET /api/v1/admin/tos-acceptances; the generated OpenAPI spec is the
// contract source of truth if they ever disagree.
export interface TosAcceptanceAdminReport {
  tosVersion: string
  signed: Array<TosAcceptanceReportUser & { acceptedAt: string }>
  unsigned: Array<TosAcceptanceReportUser & { lastLogin: string | null }>
}

export const getAdminReport = (): Promise<TosAcceptanceAdminReport> =>
  apiUtils.GET('/admin/tos-acceptances')
